import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { useForm } from "react-hook-form";
import { CircularProgress } from "@material-ui/core";
import Images from "../../../utils/styles/images";
import { REQFundRecUpDoc, ResetFundRecUpDoc } from "../redux/actions";
import "./style.scss";

// start test
const docValidation = (event) => {
  const doc = event[0];

  // Early returns for base cases
  if (!doc || doc.length === 0) { return true; }

  // Combine conditions
  const isValidType = doc.type === "application/vnd.ms-excel" || doc.type === "text/csv";
  const isValidExtension = doc.name?.split(".").pop()?.toUpperCase() === "CSV";

  return isValidType || isValidExtension;
};

const docHasBeenSelected = (inputName) => {
  if (getValues()[inputName] && getValues()[inputName].length > 0) {
    return true;
  }

  return false;
};

const renderCancelDoc = (inputName) => {
  return (
    <button
      onClick={() => setValue(inputName, "")}
      className="upload-doc-remove-doc"
    >
      <img src={Images.closeButton.close} alt="close" />
    </button>
  );
};

const renderDocStatus = (inputName) => {
  if (
    getValues()[inputName] &&
    getValues()[inputName].length > 0 &&
    errors[inputName]
  ) {
    return (
      <div className="upload-doc-error-icon">
        <img src={Images.uploadDocuments.error} alt="error" />
      </div>
    );
  } else if (getValues()[inputName] && getValues()[inputName].length > 0) {
    return (
      <div className="upload-doc-tick-icon">
        <img src={Images.uploadDocuments.tick} alt="tick" />
      </div>
    );
  } else {
    return (
      <div className="upload-doc-upload-icon">
        <img src={Images.uploadDocuments.upload} alt="upload" />
      </div>
    );
  }
};

// DocInput Component
function DocInput({ inputName, label, register, getValues, setValue, errors, renderCancelDoc, renderDocStatus }) {
  return (
    <div className="upload-doc-input-container">
      <input
        ref={register({
          required: false,
          validate: (value) => docValidation(value)
        })}
        type="file"
        name={inputName}
        id={inputName}
        className="upload-doc-input-hidden"
      />
      <label
        htmlFor={inputName}
        className="upload-doc-label-inner"
      >
        {docHasBeenSelected(inputName) ? (
          <p>{getValues()[inputName][0].name}</p>
        ) : (
          <p>{label}</p>
        )}
        {docHasBeenSelected(inputName)
          ? renderCancelDoc(inputName)
          : null}
        {renderDocStatus(inputName)}
      </label>
    </div>
  );
}

function UploadDocument(props) {
  const {
    setShowUploadDocs,
    REQFundRecUpDoc,
    ResetFundRecUpDoc,
    requestingDocumentUpload,
    uploadDocStatus
  } = props;

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    getValues,
    errors,
    watch
  } = useForm({
    mode: "onChange"
  });

  const { isValid } = formState;
  const { performanceDocument, benchmarkDocument, dividendDocument } = watch();

  const perforDocExists = performanceDocument && performanceDocument.length > 0;
  const benchDocExists = benchmarkDocument && benchmarkDocument.length > 0;
  const divDocExists = dividendDocument && dividendDocument.length > 0;
  // Can submit if form is valid and at least one doc has been selected
  const canSubmit =
    isValid && (perforDocExists || benchDocExists || divDocExists);

  const onSubmit = (data) => {
    REQFundRecUpDoc(data);
  };

  const closeModal = (e) => {
    if (!requestingDocumentUpload) {
      // don't allow exit if documents are in process of being uploaded
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
      e.stopPropagation();

      setShowUploadDocs(false);
      ResetFundRecUpDoc();
    }
  };

  return (
    <div className="upload-doc-container">
      <form className="upload-doc-modal" onSubmit={handleSubmit(onSubmit)}>
        {uploadDocStatus === "SUCCESS" ? (
          <div className={"upload-doc-success"}>
            <div className="upload-doc-header">
              <h1>Success!</h1>
              <button onClick={(e) => closeModal(e)}>
                <img src={Images.closeButton.close} alt="close" />
              </button>
            </div>
            <p>All documents were successfully uploaded</p>
            <img
              src={Images.success}
              alt="success"
              className={"upload-doc-success-img"}
            />
            <button
              className="upload-doc-ok"
              onClick={(e) => {
                ResetFundRecUpDoc();
                closeModal(e);
              }}
            >
              OK
            </button>
          </div>
        ) : (
          <Fragment> 
            {requestingDocumentUpload ? (
              <div className="upload-doc-progress">
                <CircularProgress />
                <p className="upload-doc-progress-text">
                  {requestingDocumentUpload ? "Uploading documents..." : null}
                </p>
              </div>
            ) : (
              <>
                <DocInput 
                  inputName="performanceDocument" 
                  label="Select Performance CSV"
                  register={register}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  renderCancelDoc={renderCancelDoc}
                  renderDocStatus={renderDocStatus}
                />
                <DocInput 
                  inputName="benchmarkDocument" 
                  label="Select Benchmark CSV"
                  register={register}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  renderCancelDoc={renderCancelDoc}
                  renderDocStatus={renderDocStatus} 
                />
                <DocInput 
                  inputName="dividendDocument" 
                  label="Select Dividend CSV"
                  register={register}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  renderCancelDoc={renderCancelDoc}
                  renderDocStatus={renderDocStatus}  
                />
              </>
            )}
            {uploadDocStatus === "FAILED" ? (
              <p className={"upload-doc-failed"}>
                Failed to upload documents, something went wrong.
              </p>
            ) : null}
            <div className="upload-doc-buttons">
              <button
                className="upload-doc-cancel"
                onClick={(e) => closeModal(e)}
              >
                CANCEL
              </button>
              <button
                className="upload-doc-submit"
                type="submit"
                disabled={!canSubmit}
              >
                SUBMIT
              </button>
            </div>
          </Fragment>
        )}
      </form>
    </div>
  );
}
// end test

const withConnect = connect(
  (state) => ({
    ...state.fundsListReducer
  }),
  {
    REQFundRecUpDoc,
    ResetFundRecUpDoc
  }
);

export default compose(withConnect)(UploadDocument);
